import store from 'customerPath/store'

function urlB64ToUint8Array(base64String) {
  const padding = '='.repeat((
                               4 - (
                                   base64String.length % 4
                                 )
                             ) % 4)
  const base64 = (
    base64String + padding
  ).replace(/-/g, '+').replace(/_/g, '/')

  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }

  return outputArray
}

function savePushServiceEndpoint(subscription) {
  window.fetch(new Request(`${process.env.VUE_APP_API_URL}users/push_subscription`,
    { method: 'POST', body: JSON.stringify(subscription) },
  ))
}

function subscribeToPushService(swRegistration) {
  const apiSettings = store.state && store.state.auth && store.state.auth.settings
  const data = apiSettings.vapid_public_key ?
    apiSettings.vapid_public_key :
    window.settings && window.settings.vapid_public_key ? window.settings.vapid_public_key : null
  if (data && data.vapid_public_key) {
    window.settings = data
    subscribe(data, swRegistration)
  } else {
    window.fetch(new Request(`${process.env.VUE_APP_API_URL}settings`, { method: 'GET' }))
      .then(response => response.json())
      .then(data => {
        window.settings = data
        subscribe(data, swRegistration)
      })
  }
}

function removeSubscription(subscription) {
  if (subscription) subscription.unsubscribe()
}

function unsubscribeFromPushService(swRegistration) {
  swRegistration.pushManager.getSubscription().then(removeSubscription)
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', function() {
    const data = store && store.auth && store.auth.settings && store.auth.state.settings.vapid_public_key ?
      store.auth.state.settings.vapid_public_key :
      window.settings && window.settings.vapid_public_key ? window.settings.vapid_public_key : null
    if (data && data.vapid_public_key) {
      window.settings = data
      register(data)
    } else {
      window.fetch(new Request(`${process.env.VUE_APP_API_URL}settings`, { method: 'GET' }))
        .then(response => response.json())
        .then(data => {
          window.settings = data
          register(data || null)
        })
    }
  })
}

const register = data => {
  window.serviceWorkerRegisterData = data
  const vapidPublicKey = data.vapid_public_key
  if (!vapidPublicKey) return

  Notification.requestPermission(function(status) {
    window.debugNotification = `Notification permission status: ${status}`
  })

  navigator.serviceWorker.register('/sw.js').then(
    function(reg) {
      window.debugServiceWorker = `ServiceWorker registration successful with scope: ${reg.scope}`
    },
    function(err) {
      window.debugServiceWorker = `ServiceWorker registration failed: ${err}`
    },
  )
}

const subscribe = (data, swRegistration) => {
  const vapidPublicKey = data.vapid_public_key
  if (!vapidPublicKey) return

  const swRegistrationOptions = { userVisibleOnly: true, applicationServerKey: urlB64ToUint8Array(vapidPublicKey) }

  swRegistration.pushManager.subscribe(swRegistrationOptions).then(savePushServiceEndpoint)
}

const pushService = {
  unsubscribe: function() {
    if (navigator.serviceWorker) navigator.serviceWorker.ready.then(unsubscribeFromPushService)
  },

  subscribe: function() {
    if (navigator.serviceWorker === undefined) return

    navigator.serviceWorker.ready.then(function(reg) {
      reg.pushManager.getSubscription().then(function(sub) {
        if (sub === undefined || sub === null) {
          subscribeToPushService(reg)
        } else {
          // You have subscription, update the database on your server
          savePushServiceEndpoint(sub)
        }
      })
    })
  },
}

export default pushService
